import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";

const DeleteFormDialog = ({
  visible,
  onHide,
  onConfirmDelete,
  onConfirmSoftDelete,
  formId,
}) => {
  const [deleteType, setDeleteType] = useState("hard");

  const footer = (
    <>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Delete"
        icon="pi pi-trash"
        className="p-button-danger"
        onClick={() =>
          deleteType === "hard" ? onConfirmDelete() : onConfirmSoftDelete()
        }
      />
    </>
  );

  return (
    <Dialog
      header="Confirm Delete Form"
      visible={visible}
      style={{ width: "450px" }}
      modal
      footer={footer}
      onHide={onHide}
    >
      <div className="confirmation-content">
        <i
          className="pi pi-exclamation-triangle mr-3"
          style={{ fontSize: "2rem", color: "#dc3545" }}
        />
        <span>Are you sure you want to delete this form?</span>

        <div className="field-radiobutton mt-3">
          <RadioButton
            inputId="hardDelete"
            name="deleteType"
            value="hard"
            onChange={(e) => setDeleteType(e.value)}
            checked={deleteType === "hard"}
          />
          <label htmlFor="hardDelete" className="ml-2">
            Hard Delete (permanent, cannot be undone)
          </label>
        </div>

        <div className="field-radiobutton my-3">
          <RadioButton
            inputId="softDelete"
            name="deleteType"
            value="soft"
            onChange={(e) => setDeleteType(e.value)}
            checked={deleteType === "soft"}
          />
          <label htmlFor="softDelete" className="ml-2">
            Soft Delete (can be restored later)
          </label>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteFormDialog;
